// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwindè base;
.fixed{
    position: fixed
}
.relative{
    position: relative
}
.left-0{
    left: 0px
}
.right-0{
    right: 0px
}
.top-0{
    top: 0px
}
.z-40{
    z-index: 40
}
.z-50{
    z-index: 50
}
.mb-3{
    margin-bottom: 0.75rem
}
.ml-3{
    margin-left: 0.75rem
}
.mr-3{
    margin-right: 0.75rem
}
.ms-2{
    margin-inline-start: 0.5rem
}
.ms-3{
    margin-inline-start: 0.75rem
}
.flex{
    display: flex
}
.size-6{
    width: 1.5rem;
    height: 1.5rem
}
.h-10{
    height: 2.5rem
}
.h-4{
    height: 1rem
}
.h-\\[calc\\(100\\%-1rem\\)\\]{
    height: calc(100% - 1rem)
}
.h-screen{
    height: 100vh
}
.max-h-full{
    max-height: 100%
}
.w-4{
    width: 1rem
}
.w-48{
    width: 12rem
}
.w-full{
    width: 100%
}
.min-w-\\[225px\\]{
    min-width: 225px
}
.min-w-\\[25px\\]{
    min-width: 25px
}
.max-w-2xl{
    max-width: 42rem
}
.grow{
    flex-grow: 1
}
.cursor-pointer{
    cursor: pointer
}
.flex-row{
    flex-direction: row
}
.flex-col{
    flex-direction: column
}
.items-center{
    align-items: center
}
.justify-center{
    justify-content: center
}
.justify-between{
    justify-content: space-between
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse))
}
.overflow-y-auto{
    overflow-y: auto
}
.overflow-x-hidden{
    overflow-x: hidden
}
.rounded{
    border-radius: 0.25rem
}
.rounded-lg{
    border-radius: 0.5rem
}
.rounded-b{
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem
}
.rounded-t{
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem
}
.border{
    border-width: 1px
}
.border-b{
    border-bottom-width: 1px
}
.border-t{
    border-top-width: 1px
}
.border-gray-200{
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity))
}
.border-gray-300{
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity))
}
.border-gray-400{
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity))
}
.border-gray-500{
    --tw-border-opacity: 1;
    border-color: rgb(107 114 128 / var(--tw-border-opacity))
}
.border-gray-600{
    --tw-border-opacity: 1;
    border-color: rgb(75 85 99 / var(--tw-border-opacity))
}
.border-gray-700{
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity))
}
.bg-blue-600{
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity))
}
.bg-gray-100{
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.bg-gray-700{
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity))
}
.bg-transparent{
    background-color: transparent
}
.bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.p-4{
    padding: 1rem
}
.px-4{
    padding-left: 1rem;
    padding-right: 1rem
}
.px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem
}
.px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem
}
.py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
}
.py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem
}
.py-4{
    padding-top: 1rem;
    padding-bottom: 1rem
}
.ps-4{
    padding-inline-start: 1rem
}
.text-center{
    text-align: center
}
.text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem
}
.text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem
}
.text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem
}
.font-medium{
    font-weight: 500
}
.font-semibold{
    font-weight: 600
}
.text-blue-600{
    --tw-text-opacity: 1;
    color: rgb(37 99 235 / var(--tw-text-opacity))
}
.text-gray-200{
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity))
}
.text-gray-300{
    --tw-text-opacity: 1;
    color: rgb(209 213 219 / var(--tw-text-opacity))
}
.text-gray-800{
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity))
}
.text-transparent{
    color: transparent
}
.text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.opacity-10{
    opacity: 0.1
}
.shadow{
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.outline-none{
    outline: 2px solid transparent;
    outline-offset: 2px
}
.hover\\:bg-blue-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(29 78 216 / var(--tw-bg-opacity))
}
.hover\\:bg-gray-100:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.hover\\:bg-gray-600:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity))
}
.hover\\:text-white:hover{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.focus\\:z-10:focus{
    z-index: 10
}
.focus\\:outline-none:focus{
    outline: 2px solid transparent;
    outline-offset: 2px
}
.focus\\:ring-2:focus{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}
.focus\\:ring-4:focus{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}
.focus\\:ring-blue-300:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity))
}
.focus\\:ring-blue-500:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity))
}
.focus\\:ring-blue-800:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(30 64 175 / var(--tw-ring-opacity))
}
.focus\\:ring-gray-600:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity))
}
@media (min-width: 768px){
    .md\\:inset-0{
        inset: 0px
    }
    .md\\:p-5{
        padding: 1.25rem
    }
}
@media (prefers-color-scheme: dark){
    .dark\\:border-gray-600{
        --tw-border-opacity: 1;
        border-color: rgb(75 85 99 / var(--tw-border-opacity))
    }
    .dark\\:bg-gray-700{
        --tw-bg-opacity: 1;
        background-color: rgb(55 65 81 / var(--tw-bg-opacity))
    }
    .dark\\:ring-offset-gray-800{
        --tw-ring-offset-color: #1f2937
    }
    .dark\\:focus\\:ring-blue-600:focus{
        --tw-ring-opacity: 1;
        --tw-ring-color: rgb(37 99 235 / var(--tw-ring-opacity))
    }
}
`, "",{"version":3,"sources":["webpack://./src/presentation/styles.css"],"names":[],"mappings":"AAAA,eAAe;AAEf;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,aAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0EAAmB;IAAnB,8FAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAFnB;IAAA,kBAGA;IAHA;AAGA;AAHA;IAAA,kBAGA;IAHA;AAGA;AAHA;IAAA,kBAGA;IAHA;AAGA;AAHA;IAAA,oBAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,8BAGA;IAHA;AAGA;AAHA;IAAA,2GAGA;IAHA,yGAGA;IAHA;AAGA;AAHA;IAAA,2GAGA;IAHA,yGAGA;IAHA;AAGA;AAHA;IAAA,oBAGA;IAHA;AAGA;AAHA;IAAA,oBAGA;IAHA;AAGA;AAHA;IAAA,oBAGA;IAHA;AAGA;AAHA;IAAA,oBAGA;IAHA;AAGA;AAHA;IAAA;QAAA;IAGA;IAHA;QAAA;IAGA;AAAA;AAHA;IAAA;QAAA,sBAGA;QAHA;IAGA;IAHA;QAAA,kBAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,oBAGA;QAHA;IAGA;AAAA","sourcesContent":["@tailwindè base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
